<template>
    <b-container fluid>
        <b-row>
            <b-col md="4" class="p-3 text-left">
                <h1>{{pageHeaderText}}</h1>
            </b-col>
            <b-col md="4"
                class="ml-auto p-3 text-right appCtrlButtons">
                <b-button
                  title="Share This App"
                  variant="outline-secondary"
                  @click="shareViaWebShare"
                >
                  <b-icon-share />
                </b-button>
                <b-modal
                  id="modal-1"
                  title="Share This App"
                  ref="fallback-modal"
                  @ok="handleOk"
                >
                  <b-form-textarea
                    id="fallback"
                    ref="toCopy"
                    v-model="shareUrl"
                    rows="1"
                    max-rows="6"
                  ></b-form-textarea>
                  <template #modal-footer="{ ok }">
                    <b-button size="sm" variant="primary" @click="ok()">
                      Copy URL to Clipboard
                    </b-button>
                  </template>
                </b-modal>
            </b-col>
        </b-row>
        <contact-expert
            :disableRegisterSection="disableRegisterSection"/>
        <b-row class="pt-3 pr-3">
            <b-col class="mb-3" lg="8">
                <h3 class="mb-3">{{pageSubHeaderText}}</h3>
                <h4 v-if="documentationUrl">
                    <b-link
                        target="_blank"
                        class="card-link"
                        :href="documentationUrl"
                    ><span class="bookExpert">Access our API</span></b-link>
                    to view documentation.
                </h4>
                <div
                  class="mb-3 mt-5"
                  :key="`search-${index}`"
                  v-for="(card, index) in cards"
                  >
                  <h3 v-if="card.name">{{card.name}}</h3>
                  <b-row>
                    <search-card
                    class="col-xs-12 col-md-6 col-lg-3"
                    :key="`s-${index}`"
                    :backgroundColor="card.backgroundColor"
                    :headerColor="card.headerColor"
                    :subHeaderColor="card.subHeaderColor"
                    :section="section"
                    v-for="(section, index) in card.sections"
                    />
                </b-row>
              </div>
            </b-col>
            <b-col lg="4">
                <b-card id="trust-us-card"
                    :style="{ backgroundImage: `url(${backgroundImage})` }"
                    text-variant="white"
                    class="mb-3">
                    <div class="content">
                        <h5>Trust us for</h5>
                        <ul>
                            <li>SABS and ISO compliant Address data.</li>
                            <li>Accurate and verified address results returned.</li>
                            <li>
                                Components available via API to integrate into your own solutions.
                            </li>
                            <li>Over 50 Million searchable address combinations.</li>
                        </ul>
                    </div>
                </b-card>
                <b-card id="trust-us-card">
                    <slot name="possibleUses" />
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import {
  BButton,
  BContainer,
  BCol,
  BFormTextarea,
  BCard,
  BLink,
  BIconShare,
  BRow,
} from 'bootstrap-vue';

import ContactExpert from '@/components/ContactExpert.vue';
import SearchCard from '@/components/SearchCard.vue';

const backgroundImage = require('@/assets/images/Image_1920x300.webp');

export default {
  components: {
    BButton,
    BContainer,
    BCol,
    BFormTextarea,
    BCard,
    BLink,
    BIconShare,
    BRow,
    ContactExpert,
    SearchCard,
  },
  computed: {
    shareUrl() {
      const { origin, pathname } = window.location;
      return `${origin}${pathname}`;
    },
    backgroundImage: () => backgroundImage,
  },
  destroyed() {
    window.removeEventListener('iris:share-capability', this.shareViaWebShare);
  },
  methods: {
    handleOk() {
      const Url = this.$refs.toCopy;
      Url.innerHTML = this.shareUrl;
      Url.select();
      document.execCommand('copy');
      this.$bvModal.msgBoxOk('URL Copied to Clipboard successfully', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true,
      });
    },
    shareViaWebShare() {
      if (navigator.share) {
        navigator
          .share({
            title: document.title,
            url: this.shareUrl,
          })
          .then()
          .catch(() => {
            // Handle the error!
          });
      } else {
        this.$refs['fallback-modal'].show();
      }
    },
  },
  props: {
    pageHeaderText: {
      required: true,
      type: String,
    },
    pageSubHeaderText: {
      required: true,
      type: String,
    },
    disableRegisterSection: {
      default: false,
      type: Boolean,
    },
    documentationUrl: {
      default: null,
      required: false,
      type: String,
    },
    cards: {
      default: () => [],
      required: true,
      type: Array,
    },
  },
  mounted() {
    window.addEventListener('iris:share-capability', this.shareViaWebShare);
  },
};
</script>

<style scoped>
#fallback {
  pointer-events: none;
  background-color: lightgrey;
}
.backgroundColor {
  background-color: #f8f9fa;
}
.homeBanner {
  background-image: url('../assets/images/Image_1920x300.webp');
  color: white;
  padding: 3rem!important;
}
#trust-us-card {
  background-repeat: no-repeat;
  min-height: 250px;
  border-bottom:0;
  border-color: white;
}

.content {
    padding-top: 38px;
}

</style>
